export default "__VITE_ASSET__CSd_bamP__"